/* Click linger — keep the active design (end-colour bg + black border + end-colour
   text) visible for ~1.5s after a click, beyond what :active alone supports.

   Adds an `is-clicked` class to the button on click; CSS in
   woodflore-custom.css pairs that class with the same styles as :active. */
(function () {
  var SELECTOR = '.button--primary, .button--secondary, .mp-atc-btn, .mp-ask-btn, .mp-popup__cta, .flooring-comp__cta, .flooring-comp__card-cta';
  var LINGER_MS = 1500;
  var timers = new WeakMap();

  document.addEventListener('click', function (event) {
    var btn = event.target.closest(SELECTOR);
    if (!btn) return;
    if (btn.matches('[disabled], [aria-disabled="true"]')) return;

    btn.classList.add('is-clicked');

    var existing = timers.get(btn);
    if (existing) clearTimeout(existing);

    timers.set(btn, setTimeout(function () {
      btn.classList.remove('is-clicked');
      timers.delete(btn);
    }, LINGER_MS));
  }, true);
})();
